// ABOUTME: CPO go-live (`first_visit_film`, 2026-10-10) — under no_enter_gate a first-timer sees the intro film BEFORE the landing:
// ABOUTME: the film is put on screen at load (no splash, no mic, no agent), and the landing's 'Talk to …' CTA follows its end/skip.

import { useLayoutEffect, useRef } from 'react';

/** The fact, pure: this load's first-timer gets the film ahead of the no_enter_gate landing. */
export function isFirstVisitFilm({ ux, reelMode, hasSeenIntroBefore }) {
  return !!(ux.first_visit_film && ux.no_enter_gate && reelMode && !hasSeenIntroBefore);
}

/**
 * Raises App's `showIntro` once, before entry, so every "the film is up" gate (hidden chrome, no CTA, no swipe) holds exactly as it
 * does over the post-entry film. The Projectionist boots the film itself; its end/skip (sendReelIntroFinished) lowers the flag,
 * and the welcome it would send stays held by the landing until the guest's tap.
 *
 * @param {object} p
 * @param {boolean} p.filmFirst isFirstVisitFilm() for this load
 * @param {boolean} p.started App's isExperienceStarted
 * @param {Function} [p.setShowIntro] App's film-on-screen setter
 */
export default function useFirstVisitFilm({ filmFirst, started, setShowIntro }) {
  const raisedRef = useRef(false);
  // Layout effect: raised before the first paint of the boutique, so its CTA and chrome never flash ahead of the film.
  useLayoutEffect(() => {
    if (!filmFirst || started || raisedRef.current || !setShowIntro) return;
    raisedRef.current = true;
    console.log('[FIRST_VISIT_FILM] film on screen before entry');
    setShowIntro(true);
  }, [filmFirst, started, setShowIntro]);
}
